import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupMonacoWorkers } from './monacoworkers';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

setupMonacoWorkers();



const appUrl = `${window.location.origin}/`;

const cognitoAuthConfig = {
  authority:
    'https://cognito-idp.us-west-2.amazonaws.com/us-west-2_p5h3RrKEm',

  client_id: '7kcc1dsanbusfhm6bfhc643edr',

  redirect_uri: appUrl,
  post_logout_redirect_uri: appUrl,

  response_type: 'code',
  scope: 'openid email profile',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),

  onSigninCallback: () => {
    window.history.replaceState(
      {},
      document.title,
      window.location.pathname
    );
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>

  </React.StrictMode>
);


reportWebVitals();
